import { useEffect, useState } from 'react';
import logoSegurarse from "../../../Assets/img/logo_segurarse.svg";
import icoArgentina from "../../../Assets/img/ico-argentina.png";
import icoBrasil from "../../../Assets/img/ico-brasil.png";
import icoUruguay from "../../../Assets/img/ico-uruguay.png";
import googlePlayBadge from "../../../Assets/img/playStoreLogo.png";
import appStoreBadge from "../../../Assets/img/badge_app-store_black_es.svg";
import { SegSvg } from '../../../Components/SegUI/SegSvg/SegSvg';
import { useConfig } from '../../../context/ConfigContext';
import { Link } from 'react-router-dom';
import icoManager from "../../../Assets/img/ico-manager.svg";

interface Props {
    rubro: string;
}

const banderas: Record<"AR" | "UY" | "BR", { icon: string; label: string; url: string }> = {
    AR: { icon: icoArgentina, label: "AR", url: "https://segurarse.com.ar/" },
    BR: { icon: icoBrasil, label: "BR", url: "https://segurarse.com.br/" },
    UY: { icon: icoUruguay, label: "UY", url: "https://segurarse.com.uy/" }
};

export const Navbar = ({ rubro }: Props) => {

    const { config, origen: origenData, isLoading } = useConfig()
    const current = banderas[config!.pais];

    const [animDelay, setAnimDelay] = useState('0s');

    useEffect(() => {
        const heroSlider = document.querySelector('.sec-hero .word-slider__words--4w');
        if (heroSlider) {
            const animations = heroSlider.getAnimations();
            if (animations.length > 0 && animations[0].currentTime !== null) {
                const currentTimeMs = animations[0].currentTime as number;
                const offset = (currentTimeMs % 8000) / 1000;
                setAnimDelay(`-${offset}s`);
            }
        }
    }, []);
    
    // const [esMiSegurarse, setEsMiSegurarse] = useState(false);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setEsMiSegurarse(prev => !prev);
    //     }, 1750);
    //     return () => clearInterval(interval);
    // }, []);

    return (
        <>
            <header className="site-header-landing">
                <SegSvg color={origenData!.origen !== "SEGURARSE" ? origenData!.bgColor : undefined} />
                <nav className="navbar navbar-expand-lg navbar2 bg-white fixed-top">
                    <div className="container-fluid container g-0 gx-xl-4 d-flex">
                        <div className={`content ${origenData!.origen === "SEGURARSE" ? "w-fit" : ""}`}>
                            <div className='d-flex gap-3 align-items-center justify-center'>
                                <Link className="navbar-brand ms-lg-0 me-0" to="/">
                                    <img className="logo-se-header" src={logoSegurarse} alt="Segurarse" />
                                </Link>
                                {
                                    (!isLoading && origenData!.origen !== "SEGURARSE") &&
                                    <Link className="navbar-brand ms-lg-0 me-0" to="/">
                                        <img className="logo-se-header2" src={origenData!.logo} alt={origenData!.origen} />
                                    </Link>
                                }
                            </div>
                            <div id="animable" className={(!isLoading && origenData!.origen === "SEGURARSE") ? 'expandido' : ''}></div>
                        </div>

                        <div className={`actions ${(isLoading || origenData!.origen !== "SEGURARSE") ? "d-none" : ""}`}>
                            <div className="dropdown ms-auto d-lg-none">
                                <a
                                    className="dropdown-toggle dropdown-toggle--menu ps-10"
                                    href="#"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <span>
                                        <img src={current.icon} width="17" className="mb-1 me-1" alt={current.label} />
                                        {current.label}
                                    </span>
                                </a>
                                <ul className="dropdown-menu dropdown-menu--se dropdown-menu--paises">
                                    {Object.entries(banderas).map(([code, { icon, label, url }]) => {
                                        if (code === config!.pais) return null;
                                        return (
                                            <li key={code}>
                                                <Link className="dropdown-item" to={url}>
                                                    <img src={icon} width="17" className="me-1" alt={label} /> {label}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>

                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                                aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"
                                style={{ borderStyle: "none" }}>
                                <span className="navbar-toggler-icon"></span>
                            </button>
                        </div>

                        {
                            (!isLoading && origenData!.origen === "SEGURARSE") &&
                            <div className="collapse navbar-collapse sliding-menu" id="navbarNav">
                                <ul className="navbar-nav h-full navbar-nav--se justify-content-lg-end flex-grow-1 mt-2 mt-lg-0">
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/seguros-individuos">Individuos</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to="/seguros-corporativos">Corporativos</Link>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <Link
                                            className="nav-link dropdown-toggle dropdown-toggle--menu"
                                            to="#"
                                            role="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            Ayuda
                                        </Link>
                                        <ul className="dropdown-menu dropdown-menu--se">
                                            <li>
                                                <Link className="dropdown-item"
                                                    to="/preguntas-frecuentes">Preguntas Frecuentes</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to="/contacto">Contacto</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <a
                                            className="nav-link dropdown-toggle dropdown-toggle--menu"
                                            href="#"
                                            role="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            Nosotros
                                        </a>
                                        <ul className="dropdown-menu dropdown-menu--se">
                                            <li>
                                                <Link className="dropdown-item"
                                                    to="/quienes-somos">Quiénes somos</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item"
                                                    to="/nuestro-oneteam">Sumate al #OneTeam</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" to="/sustentabilidad">Sustentabilidad</Link>
                                            </li>
                                            <li className="d-lg-none">
                                                <Link className="dropdown-item"
                                                    to="/politicas-privacidad">Políticas de Privacidad</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link"
                                            href={`https://segurarse.com.${config.pais.toLocaleLowerCase()}/blog`}>
                                            Blog
                                        </a>
                                    </li>
                                    <li className="nav-item text-center text-lg-start me-2">
                                        {(config.pais === "AR" || config.pais === "UY") ? (
                                            <a
                                                className="nav-link w-100 text-white nav-link-cta mt-4 mt-lg-0"
                                                href="/autogestion/ingreso"
                                                style={{
                                                    backgroundColor: '#2c7dfd',
                                                    whiteSpace: 'nowrap',
                                                    minWidth: '180px',
                                                    textAlign: 'center',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    height: '40px',
                                                }}
                                            >
                                                <img
                                                    src={icoManager}
                                                    alt=""
                                                    style={{ width: 22, height: 22, marginRight: 12, flexShrink: 0, verticalAlign: 'baseline', filter: 'brightness(0) invert(1)' }}
                                                />
                                                <span>MI SEGURARSE</span>
                                            </a>
                                        ) : (
                                            <div className="nav-item dropdown d-lg-none d-xl-block">
                                                <a
                                                    className="nav-link dropdown-toggle dropdown-toggle--menu"
                                                    href="#"
                                                    role="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    Mi Segurarse
                                                </a>
                                                <ul className="dropdown-menu dropdown-menu--se p-lg-3">
                                                    <li>Descargá la App!</li>
                                                    <li className="list-inline-item">
                                                        <a href="https://play.google.com/store/apps/details?id=com.segurarse.misegurarse&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" target="_blank" rel="noreferrer">
                                                            <img className="mt-2 badge-store-menu" alt="Disponible en Google Play" src={googlePlayBadge} />
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <a href="https://apps.apple.com/ar/app/mi-segurarse/id1237342800" target="_blank" rel="noreferrer">
                                                            <img className="mt-2 badge-store-menu" alt="Descárgalo en el App Store" src={appStoreBadge} />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                    </li>
                                    <PaisSelector pais={config!.pais} />
                                    <li className="nav-item text-center text-lg-start">
                                        <Link
                                            className="nav-link w-100 bg-orange1 text-white nav-link-cta mt-2 mt-lg-0"
                                            to={rubro === "auto" ? "/cotizador-de-seguros-auto" : "/prepaga/individuo"}
                                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '40px' }}
                                        >
                                            <svg className="svg-icon nav-link-cta-icon me-2" style={{ marginBottom: 0, verticalAlign: 'middle' }}>
                                                <use xlinkHref={rubro === "auto" ? "#ico-auto" : ""} fill='white' />
                                            </svg>
                                            <div className="word-slider" style={{ background: 'none', marginBottom: 0 }}>
                                                <ul className="word-slider__words word-slider__words--4w" style={{ animationDelay: animDelay }}>
                                                    <li className="word-slider__word">COTIZÁ</li>
                                                    <li className="word-slider__word">COMPARÁ</li>
                                                    <li className="word-slider__word">COTIZÁ</li>
                                                    <li className="word-slider__word">COMPARÁ</li>
                                                    <li className="word-slider__word">COTIZÁ</li>
                                                </ul>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        }
                    </div>
                </nav>
            </header>

            <section className={`navbarloading ${isLoading ? 'show' : 'hide'}`}>
                <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                </div>
            </section>

        </>
    );
};

interface PropsPais {
    pais: "AR" | "UY" | "BR"
}
export const PaisSelector = ({ pais }: PropsPais) => {
    const current = banderas[pais];
    return (
        <li className="nav-item dropdown order-lg-last d-none d-lg-block">
            <a
                className="nav-link dropdown-toggle dropdown-toggle--menu"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <span>
                    <img src={current.icon} width="17" className="mb-1 me-1" alt={current.label} /> {current.label}
                </span>
            </a>
            <ul className="dropdown-menu dropdown-menu--se">
                {Object.entries(banderas).map(([code, { icon, label }]) => {
                    if (code === pais) return null;
                    const url =
                        code === "BR"
                            ? "https://segurarse.com.br/"
                            : code === "UY"
                                ? "https://segurarse.com.uy/"
                                : "https://segurarse.com.ar/";
                    return (
                        <li key={code}>
                            <Link className="dropdown-item" to={url}>
                                <img src={icon} width="17" className="me-1" alt={label} /> {label}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </li>
    );
};